import React from 'react';
import {HtmlParse} from 'utils';
import Link from 'components/Link';
import helpCenter from 'images/help-center/cencommerce-help-center.svg';
import style from './style.scss';//NOSONAR

const PreHeader = () => {
    return(
        <div className="pre-header-wrapper">
            <div className="pre-header-container">
                <Link className="pre-header-link help-center-link" to='https://ayuda.jumbo.cl' target='_blank'>
                    <i className="helpcenter-icon">{HtmlParse(helpCenter)}</i>
                    <span>Centro de ayuda</span>
                </Link>
                <Link className="pre-header-link" to='/mis-compras'>Estado del pedido</Link>
                <Link className="pre-header-link" to='/locales'>Locales</Link>
            </div>
        </div>
    )
}

export default PreHeader;
